import { PayloadAction, createSlice } from '@reduxjs/toolkit'
import { BenefitState } from './types'
import { BenefitService } from '../../services/benefit/BenefitService'

const initialState: BenefitState = {
  isGetAllBenefitsLoading: false,
  isCreateOrUpdateLoading: false,
  benefits: []
}

const slice = createSlice({
  name: 'benefit',
  initialState,
  reducers: {
    changeBenefitDescription: (state, action: PayloadAction<{ value: string; index: number }>) => {
      const index = action.payload.index
      state.benefits[index].description = action.payload.value
    },
    setBenefitsImage: (state, action: PayloadAction<{ file: File; index: number }>) => {
      const index = action.payload.index
      state.benefits[index].image = action.payload.file
    },
    deleteBenefitPreviewImage: (state, action: PayloadAction<number>) => {
      const index = action.payload
      state.benefits[index].imageUrl = ''
    },
    resetBenefitState: () => initialState
  },
  extraReducers: (builder) => {
    builder
      .addCase(BenefitService.getBenefitsAsyncThunk.pending, (state) => {
        state.isGetAllBenefitsLoading = true
      })
      .addCase(BenefitService.getBenefitsAsyncThunk.rejected, (state) => {
        state.isGetAllBenefitsLoading = false
      })
      .addCase(BenefitService.getBenefitsAsyncThunk.fulfilled, (state, action) => {
        state.isGetAllBenefitsLoading = false
        state.benefit = action.payload.benefit
        state.benefits = action.payload.benefit.benefits.map((benefit) => ({ ...benefit, image: null }))
      })
      .addCase(BenefitService.createOrUpdateBenefitsAsyncThunk.pending, (state) => {
        state.isCreateOrUpdateLoading = true
      })
      .addCase(BenefitService.createOrUpdateBenefitsAsyncThunk.rejected, (state) => {
        state.isCreateOrUpdateLoading = false
      })
      .addCase(BenefitService.createOrUpdateBenefitsAsyncThunk.fulfilled, (state) => {
        state.isCreateOrUpdateLoading = false
      })
  }
})

export const { resetBenefitState, setBenefitsImage, deleteBenefitPreviewImage, changeBenefitDescription } =
  slice.actions
export default slice.reducer
